import { contactRequestsMutations } from '@/api/endpoints/contact-requests/mutations'
import { ContactRequestData } from '@/types/contact-request-types'
import { useMutation } from '@tanstack/react-query'

export const useSubmitContactRequest = () => {
  const mutation = useMutation({
    mutationKey: ['contactRequests', 'submit'],
    mutationFn: contactRequestsMutations.submit,
    retry: 1,
  })

  return {
    requestData: (data: ContactRequestData) => mutation.mutateAsync(data),
    loading: mutation.isPending,
    error: mutation.error?.message || null,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
    data: mutation.data,
  }
}
